import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

// =====================================================
// LIST STORIES
// =====================================================

export async function getStoriesApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);
    fd.append("search", payload.search || "");
    fd.append("type", payload.type || "");
    fd.append("niche", payload.niche || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/stories/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Stories Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Stories fetch failed",
    };
  }
}

// =====================================================
// STORY STATS
// =====================================================

export async function getStoryStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/stories/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Story Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Story stats fetch failed",
    };
  }
}

// =====================================================
// VIEW STORY
// =====================================================

export async function getStoryApi(storyId) {
  try {
    const fd = new FormData();

    fd.append("story_id", storyId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/stories/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Story Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Story fetch failed",
    };
  }
}

// =====================================================
// CREATE STORY
// =====================================================

export async function createStoryApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "story_title",
      payload.story_title || ""
    );

    fd.append(
      "story_meta_title",
      payload.story_meta_title || ""
    );

    fd.append(
      "story_keyword",
      payload.story_keyword || ""
    );

    fd.append(
      "story_parent",
      payload.story_parent || ""
    );

    fd.append(
      "story_parent_type",
      payload.story_parent_type || ""
    );

    fd.append(
      "story_niche",
      payload.story_niche || ""
    );

    fd.append(
      "story_handle",
      payload.story_handle || ""
    );

    fd.append(
      "story_typ",
      payload.story_typ || ""
    );

    fd.append(
      "story_listners",
      payload.story_listners || ""
    );

    fd.append(
      "story_price",
      payload.story_price ?? ""
    );

    fd.append(
      "story_creator",
      payload.story_creator || ""
    );

    fd.append(
      "story_img",
      payload.story_img || ""
    );

    fd.append(
      "story_video",
      payload.story_video || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/stories/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Story Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Story creation failed",
    };
  }
}

// =====================================================
// UPDATE STORY
// =====================================================

export async function updateStoryApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "story_id",
      payload.story_id || ""
    );

    fd.append(
      "story_title",
      payload.story_title || ""
    );

    fd.append(
      "story_meta_title",
      payload.story_meta_title || ""
    );

    fd.append(
      "story_keyword",
      payload.story_keyword || ""
    );

    fd.append(
      "story_parent",
      payload.story_parent || ""
    );

    fd.append(
      "story_parent_type",
      payload.story_parent_type || ""
    );

    fd.append(
      "story_niche",
      payload.story_niche || ""
    );

    fd.append(
      "story_handle",
      payload.story_handle || ""
    );

    fd.append(
      "story_typ",
      payload.story_typ || ""
    );

    fd.append(
      "story_listners",
      payload.story_listners || ""
    );

    fd.append(
      "story_price",
      payload.story_price ?? ""
    );

    fd.append(
      "story_creator",
      payload.story_creator || ""
    );

    fd.append(
      "story_img",
      payload.story_img || ""
    );

    fd.append(
      "story_video",
      payload.story_video || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/stories/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Story Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Story update failed",
    };
  }
}

// =====================================================
// DELETE STORY
// =====================================================

export async function deleteStoryApi(storyId) {
  try {
    const fd = new FormData();

    fd.append(
      "story_id",
      storyId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/stories/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Story Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Story deletion failed",
    };
  }
}